import { Match } from 'effect';
import thePlatformProvider from './fairplay-providers/the-platform.ts';
import defaultProvider from './fairplay-providers/default.ts';

function setupWidevine(player: any, drm: any) {
  player.eme();
  return {
    keySystems: { 'com.widevine.alpha': drm.widevine.license_url },
    type: 'application/dash+xml',
  };
}

export function drmSetup(player: any, drm: any, type?: string) {
  return Match.value({ type, drm }).pipe(
    Match.when(
      { drm: (drm: any) => Object.keys(drm || {}).length === 0 },
      () => {
        return {};
      }
    ),
    Match.when({ type: 'application/dash+xml' }, ({ drm }) =>
      setupWidevine(player, drm)
    ),
    Match.when(
      {
        drm: (drm: any) => {
          const drmKeys = Object.keys(drm);
          return drmKeys.length === 1 && drmKeys.includes('widevine');
        },
      },
      ({ drm }) => setupWidevine(player, drm)
    ),
    Match.when(
      { drm: (drm: any) => drm?.fairplay?.provider === 'theplatform' },
      ({ drm }) => thePlatformProvider(player, drm)
    ),
    Match.when(
      {
        type: (type) => ['application/x-mpegURL', 'video/hls'].includes(type),
      },
      ({ drm }) => defaultProvider(player, drm)
    ),
    Match.orElse(() => {
      return {};
    })
  );
}
